<template>
  <div class="flex" :class="size">
    <slot :value="value" :errorMessage="errorMessage">
      <ToggleSwitch v-if="props.switch" v-on:keydown.enter.prevent v-model="value" class="h-6" :inputId="props.name" />
      <Checkbox
        v-else
        v-on:keydown.enter.prevent
        :inputId="props.name"
        :name="props.name"
        v-model="value"
        :binary="true"
        class="my-auto"
        :size="checkboxSize"
      />
    </slot>
    <slot name="label">
      <label :for="props.name" :class="props.classes">{{ label }}</label>
    </slot>
  </div>
  <small v-if="errorMessage" :id="props.name + '-help'" class="text-red-400">{{ errorMessage }}</small>
</template>

<script setup lang="ts">
import { useField } from "vee-validate";

interface Props {
  name: string;
  value?: string;
  label: string;
  size?: string;
  classes?: string;
  switch?: boolean;
  checkboxSize?: "small" | "large" | undefined;
}
const props = withDefaults(defineProps<Props>(), {
  size: "w-full",
  classes: "font-bold ml-2",
  switch: false,
});

const { value, errorMessage } = useField<boolean>(() => props.name);
</script>
